Ext.define('SA.model.map.LegendOverlay', {
    extend: 'SA.model.map.ExportOverlay',

    fields: [
        {name: 'theme', defaultValue: 'light'}
    ],

    getTheme() {
        return this.get('theme');
    },

    setTheme(theme) {
        this.setWithEvent('theme', theme);
    }
});
